<app-pat-payment-method-picker-block
  (selectedPaymentMethodEmitter)="onSelectedPaymentMethod($event)"
></app-pat-payment-method-picker-block>
